export function createAttachmentFormData({ as, file }: { as: string; file: File }): FormData {
    const data = new FormData();
    data.append('as', as);
    data.append('attachment', file);
    return data;
}
